
import {
  TBaseTypographyProps,
  TTypographyAlign,
  TTypographyAlignSubsetProp,
  TTypographyColor,
  TTypographyTag,
  TTypographyWhitespace,
  BASE_TYPOGRAPHY_DEFAULTS,
} from "@/ui/components/typography/typography.config";
import { DefinedDefaults, SubsetKeys, subsetOf } from "@/ui/lib/types";

/*-------------------------------------
|  Constants
|-------------------------------------*/

export const AVAILABLE_TEXT_SUBTITLE_TAGS = subsetOf<TTypographyTag>()([ "h2", "h3", "h4", "h5", "h6", "div", "span" ]);

export const AVAILABLE_TEXT_SUBTITLE_COLORS =
  subsetOf<TTypographyColor>()([ "default" ]);

export const AVAILABLE_TEXT_SUBTITLE_ALIGNMENTS =
  subsetOf<TTypographyAlign>()([ "left", "center" ]);

export const AVAILABLE_TEXT_SUBTITLE_WHITESPACE =
  subsetOf<TTypographyWhitespace>()([ "normal", "balance" ]);

export const BASE_TEXT_SUBTITLE_SIZE_CLASS_MAP = {
  1: "text-sys-2xl",
  2: "text-sys-xl",
  3: "text-sys-lg",
  4: "text-sys-base",
} as const;

export const RESPONSIVE_TEXT_SUBTITLE_SIZE_CLASS_MAP = {
  1: `${BASE_TEXT_SUBTITLE_SIZE_CLASS_MAP[1]} xl:text-sys-4xl`,
  2: `${BASE_TEXT_SUBTITLE_SIZE_CLASS_MAP[2]} xl:text-sys-2xl`,
  3: `${BASE_TEXT_SUBTITLE_SIZE_CLASS_MAP[3]} xl:text-sys-xl`,
  4: `${BASE_TEXT_SUBTITLE_SIZE_CLASS_MAP[4]} xl:text-sys-xl`,
} as const;

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TTextSubtitleTag = SubsetKeys<typeof AVAILABLE_TEXT_SUBTITLE_TAGS>;
export type TTextSubtitleColor = SubsetKeys<typeof AVAILABLE_TEXT_SUBTITLE_COLORS>;
export type TTextSubtitleAlign = SubsetKeys<typeof AVAILABLE_TEXT_SUBTITLE_ALIGNMENTS>;
export type TTextSubtitleWhitespace = SubsetKeys<typeof AVAILABLE_TEXT_SUBTITLE_WHITESPACE>;
export type TTextSubtitleSize = keyof typeof BASE_TEXT_SUBTITLE_SIZE_CLASS_MAP;

export type TTextSubtitleProps = TBaseTypographyProps & {
  color?: TTextSubtitleColor;
  align?: TTypographyAlignSubsetProp<TTextSubtitleAlign>;
  tag?: TTextSubtitleTag;
  whitespace?: TTextSubtitleWhitespace;
  size?: TTextSubtitleSize;
};

type TTextSubtitleDefaultProps = DefinedDefaults<
  TTextSubtitleProps,
  "color" | "align" | "tag" | "whitespace" | "size"
>;

/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const TEXT_SUBTITLE_DEFAULTS = {
  ...BASE_TYPOGRAPHY_DEFAULTS,
  color: "default",
  align: "left",
  tag: "h2",
  whitespace: "normal",
  size: 2,
} satisfies TTextSubtitleDefaultProps;
